import { FC } from 'react';

import { Rubric, RUBRIC_TYPES } from '../Datatable.types';

import { FiltersDate } from './FiltersDate';
import { FiltersDefault } from './FiltersDefault';
import { FiltersNumeric } from './FiltersNumeric';
import { FiltersPercentage } from './FiltersPercentage';
import { FiltersRange } from './FiltersRange';

interface DatatableFiltersItemProps {
  filter?: Rubric;
  onChange: (selectedValues: Rubric) => void;
  dataTestId?: string;
}

const DatatableFiltersItem: FC<DatatableFiltersItemProps> = ({
  filter,
  onChange,
  dataTestId,
}) => {
  return filter ? (
    <>
      {filter.type === RUBRIC_TYPES.DEFAULT && (
        <FiltersDefault
          filter={filter}
          onChange={onChange}
          dataTestId={dataTestId}
        />
      )}
      {filter.type === RUBRIC_TYPES.DATE && (
        <FiltersDate
          filter={filter}
          onChange={onChange}
          dataTestId={dataTestId}
        />
      )}
      {filter.type === RUBRIC_TYPES.NUMERIC && (
        <FiltersNumeric
          filter={filter}
          onChange={onChange}
          dataTestId={dataTestId}
        />
      )}
      {filter.type === RUBRIC_TYPES.RANGE_NUMERIC && (
        <FiltersRange
          filter={filter}
          onChange={onChange}
          dataTestId={dataTestId}
        />
      )}
      {filter.type === RUBRIC_TYPES.PERCENTAGE && (
        <FiltersPercentage
          filter={filter}
          onChange={onChange}
          dataTestId={dataTestId}
        />
      )}
    </>
  ) : (
    <></>
  );
};

DatatableFiltersItem.displayName = 'DatatableFiltersItem';

export default DatatableFiltersItem;
